import React from "react";
import AnalysisView from "@views/AnalysisView";
import AdvancedAnalyticsView from "@views/AdvancedAnalyticsView";
import AssetAdminView from "@views/AssetAdminView";
import DeviceManagementView from "@views/DeviceManagementView";
import IncomeSecurityView from "@views/IncomeSecurityView";
import KioskView from "@views/KioskView";
import LiveFloorView from "@views/LiveFloorView";
import ReportsView from "@views/ReportsView";
import RevenueView from "@views/RevenueView";
import SessionsView from "@views/SessionsView";
import SiteInstallationsView from "@views/SiteInstallationsView";
import SystemAdminView from "@views/SystemAdminView";
import TransactionsView from "@views/TransactionsView";
import UserAdminView from "@views/UserAdminView";
import ComplianceView from "@views/ComplianceView";
import CustomerView from "@views/CustomerView";

const availablePanes = [
  {
    key: "GENERAL_INSTALL",
    title: "Site Installations",
    component: <SiteInstallationsView />,
  },
  {
    key: "GENERAL_COMMS",
    title: "Live Floor View",
    component: <LiveFloorView />,
  },
  {
    key: "GENERAL_COLLECTIONS",
    title: "Revenue",
    component: <RevenueView />,
  },
  {
    key: "GENERAL_INCOMESECURITY",
    title: "Income Security",
    component: <IncomeSecurityView />,
  },
  {
    key: "GENERAL_TRANS",
    title: "Transactions",
    component: <TransactionsView />,
  },
  {
    key: "COMPLIANCE",
    title: "Compliance",
    component: <ComplianceView />,
  },
  {
    key: "CUSTOMERS",
    title: "Customers",
    component: <CustomerView />,
  },
  {
    key: "GENERAL_ANALYSIS",
    title: "Analysis",
    component: <AnalysisView />,
  },
  {
    key: "GENERAL_SESSIONS",
    title: "Sessions",
    component: <SessionsView />,
  },
  {
    key: "GENERAL_REPORTS",
    title: "Reports",
    component: <ReportsView />,
  },
  {
    key: "KIOSK",
    title: "Kiosk",
    component: <KioskView />,
  },
  {
    key: "GENERAL_USERADMIN",
    title: "User Admin",
    component: <UserAdminView />,
  },
  {
    key: "GENERAL_SYSADMIN",
    title: "System Admin",
    component: <SystemAdminView />,
  },
  {
    key: "GENERAL_ASSETADMIN",
    title: "Asset Admin",
    component: <AssetAdminView />,
  },
  {
    key: "GENERAL_DEVICEADMIN",
    title: "System Hardware Admin",
    component: <DeviceManagementView />,
  },
  {
    key: "ADVANCED_ANALYTICS",
    title: "Advanced analytics",
    component: <AdvancedAnalyticsView />,
  },
];

export default availablePanes;
